function nonEmptyString(value: unknown): string | undefined {
  return typeof value === 'string' && value.trim() ? value : undefined
}

/** Extract proxy/RTK error payloads before falling back to ordinary Error text. */
export function extractErrorMessage(error: unknown, fallback = String(error)): string {
  if (error && typeof error === 'object') {
    const record = error as Record<string, unknown>
    if (record.data && typeof record.data === 'object') {
      const data = record.data as Record<string, unknown>
      const message = nonEmptyString(data.error) ?? nonEmptyString(data.message)
      if (message) return message
    }
    const message = nonEmptyString(record.error) ?? nonEmptyString(record.message)
    if (message) return message
  }
  return error instanceof Error && error.message ? error.message : fallback
}
